import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';

@Component({
  imports: [FlexLayoutModule],
  selector: 'iot-platform-ui-timeline',
  templateUrl: './timeline.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./timeline.component.scss']
})
export class TimelineComponent {}
